import React from "react";

const TableColumn: React.FC<{
  columnHeaders: string[];
  columnItems: {
    name: string;
    price: number;
    medicalExpenses: number;
    accidentInsurance: boolean;
    belongingsLuggage: any;
    civicLifeResponsibility: any;
    hospitalStay: any;
    aboveAssistance: any;
  };
  modalToggleHandler: any;
}> = (props) => {
  return (
    <div
      className={`table__column ${
        props.columnItems?.name === "Premium" ? "table__column--premium" : ""
      }`}
    >
      <div className="table__column__left">
        <div className="table__column__header">
          <span className="table__column__item text--secondary">
            Insurance package
          </span>
        </div>
        {props.columnHeaders?.map((columnHeader) => (
          <div
            className="table__column__item text--secondary"
            key={columnHeader}
          >
            {columnHeader}
          </div>
        ))}
      </div>
      <div className="table__column__right">
        <div className="table__column__header">
          {props.columnItems?.name === "Premium" ? (
            <span className="column-cell chip">Best Offer</span>
          ) : null}
          <span className="column-cell text--secondary">
            {props.columnItems?.name}
          </span>
          <span className="column-cell heading--primary">
            {typeof props.columnItems.price === "number"
              ? `$${props.columnItems?.price}`
              : "--"}{" "}
          </span>
        </div>
        <div className="table__column__items text--secondary">
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number"
              ? `$${props.columnItems?.medicalExpenses.toLocaleString("en")}`
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number" &&
            props.columnItems?.accidentInsurance
              ? props.columnItems?.accidentInsurance
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number" &&
            props.columnItems?.belongingsLuggage
              ? props.columnItems?.belongingsLuggage
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number" &&
            props.columnItems?.civicLifeResponsibility
              ? `$${props.columnItems?.civicLifeResponsibility.toLocaleString(
                  "en"
                )}`
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number" &&
            props.columnItems?.hospitalStay
              ? props.columnItems?.hospitalStay
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            {typeof props.columnItems?.price === "number" &&
            props.columnItems?.aboveAssistance
              ? props.columnItems?.aboveAssistance
              : "-"}
          </div>
          <div className="table__column__item text--secondary">
            <div
              // className={`cta ${
              //   props.columnItems?.name === "Premium"
              //     ? "cta--light"
              //     : "cta--primary"
              // }`}
              className="cta cta--primary"
              onClick={props.modalToggleHandler}
            >
              Select package
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableColumn;
